import {mergeSxs} from '@hconnect/uikit/src/lib2'
import {Box, SxProps, Theme, Typography} from '@mui/material'
import React from 'react'

export const LegendItem = ({
  color,
  label,
  variant = 'circle',
  sx,
  'data-test-id': dataTestId
}: {
  color: string
  label: string
  variant?: 'circle' | 'square' | 'line'
  sx?: SxProps<Theme>
  'data-test-id'?: string
}) => (
  <Typography
    display="flex"
    variant="caption"
    alignItems="center"
    color="textPrimary"
    data-test-id={dataTestId}
  >
    {(variant === 'circle' || variant === 'square') && (
      <Box
        component="span"
        mr={0.5}
        sx={mergeSxs(
          {
            backgroundColor: color,
            verticalAlign: 'text-bottom',
            width: 12,
            height: 12,
            borderRadius: variant === 'square' ? 0 : '50%'
          },
          sx
        )}
      />
    )}
    {variant === 'line' && (
      <Box
        component="span"
        mr={0.5}
        sx={{
          backgroundColor: color,
          height: 2,
          width: 16,
          borderRadius: 1
        }}
      />
    )}
    {label}
  </Typography>
)
